import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { useHistory, useParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { Checkbox } from "primereact/checkbox";
import PrestadorService from "../../service/PrestadorService";

const tipoPrestadorService = new PrestadorService(); // Create an instance of LojaService

const CadastrarTipoPrestador = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let tipoPrestadorNovo = {
        id: null,
        nome: '',
        descricao: '',
        ativo: true,
    };

    const [tipoPrestador, setTipoPrestador] = useState(tipoPrestadorNovo);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    useEffect(() => {

        if (id != null) {
            setLoading(true);
            tipoPrestadorService.getTipoPrestador(iss, id).then(data => {
                setLoading(false);
                tipoPrestadorNovo = data.data.rows[0];

                setTimeout(() => {

                    setTipoPrestador(tipoPrestadorNovo);
                }, 200);

            });
        }
    }, []); //

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        if (checkbox) {
            val = e.checked;
        }

        let _tipoPrestador = { ...tipoPrestador };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_tipoPrestador[parent]) {
                _tipoPrestador[parent] = {}; // Cria o objeto pai se não existir
            }
            _tipoPrestador[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _tipoPrestador[name] = val;
            } else {
                _tipoPrestador[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setTipoPrestador(_tipoPrestador);

    }

    function removeDuplicatesById(arr) {
        const idCounts = new Map();

        // Count occurrences of each id
        arr.forEach(item => {
            if (idCounts.has(item.id)) {
                idCounts.set(item.id, idCounts.get(item.id) + 1);
            } else {
                idCounts.set(item.id, 1);
            }
        });

        // Filter out items with duplicate ids
        return arr.filter(item => idCounts.get(item.id) === 1);
    }

    const cadastrar = () => {
        setSubmitted(true);
        if (tipoPrestador.nome && tipoPrestador.descricao) {
            let _tipoPrestador = { ...tipoPrestador };
            setLoading(true)

            if (_tipoPrestador.id != null) {
                tipoPrestadorService.putTipoPrestador(iss, _tipoPrestador, _tipoPrestador.id).then(data => {
                    showToast({ severity: 'success', summary: 'Colaborador editada', detail: 'Colaborador editada com sucesso' });
                    history.push('/prestador/tipo/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar tipoPrestador' });
                }).finally(() => { setLoading(false) });
            } else {
                tipoPrestadorService.postTipoPrestador(iss, _tipoPrestador).then(data => {
                    showToast({ severity: 'success', summary: 'Tipo cadastrada', detail: 'Tipo cadastrado com sucesso' });
                    history.push('/prestador/tipo/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Erro ao cadastrar tipoPrestador' });
                }).finally(() => { setLoading(false) });
            }


        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }

    }

    return (
        <div className="grid">
            <h4>Informações do tipo prestador</h4>
            <div className="col-12">
                <div className="card">

                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-6">
                            <span className="p-float-label">
                                <InputText value={tipoPrestador.nome}
                                    onChange={(e) => onInputChange(e, 'nome')}
                                    className={classNames({ 'p-invalid': submitted && !tipoPrestador.nome })}
                                    required
                                    id="nome" type="text" />
                                <label htmlFor="nome">Nome</label>
                            </span>
                            {submitted && !tipoPrestador.nome &&
                                <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-6">
                            <span className="p-float-label">
                                <InputText value={tipoPrestador.descricao}
                                    onChange={(e) => onInputChange(e, 'descricao')}
                                    className={classNames({ 'p-invalid': submitted && !tipoPrestador.descricao })}
                                    required
                                    id="descricao" type="text" />
                                <label htmlFor="descricao">Descrição</label>
                            </span>
                            {submitted && !tipoPrestador.loginAlias &&
                                <small className="p-invalid">Descrição é obrigatório.</small>}
                        </div>

                        <div className="col-12 md:col-4">
                            <div className="field-checkbox">
                                <Checkbox inputId="ativoOption" name="ativo"
                                    checked={tipoPrestador.ativo}
                                    onChange={(e) => {
                                        onInputChange(e, 'ativo', false, true)
                                    }} />
                                <label htmlFor="ativoOption">Ativo</label>
                            </div>
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarTipoPrestador, comparisonFn);
